var _path, _path2, _path3, _path4, _mask, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTrophyActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H7V7C7 8.66667 8 12 12 12C16 12 17 8.66667 17 7V2Z",
    stroke: "#10F48B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4H20C20.5523 4 21 4.44772 21 5V7C21 8.16667 21 10 16 10",
    stroke: "#10F48B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4H4C3.44772 4 3 4.44772 3 5V7C3 8.16667 3 10 8 10",
    stroke: "#10F48B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V17",
    stroke: "#10F48B",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_191_3352",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 18C7 17.4477 7.44772 17 8 17H16C16.5523 17 17 17.4477 17 18V23H7V18Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18C7 17.4477 7.44772 17 8 17H16C16.5523 17 17 17.4477 17 18V23H7V18Z",
    stroke: "#10F48B",
    strokeWidth: 4,
    mask: "url(#path-5-inside-1_191_3352)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrophyActive);
export default __webpack_public_path__ + "static/media/ic_trophy_active.5b70c0cf391d390774e14403384916c3.svg";
export { ForwardRef as ReactComponent };